/**
 * @typedef {ReturnType <typeof import('widgets/global/Refinement').default>} Refinement
 * @typedef {ReturnType <typeof import('widgets/global/Button').default>} Button
 */

/**
 * @param {Refinement} Refinement Refinement
 * @returns {typeof HarmonyRefinement} HarmonyRefinement
 */
export default function (Refinement) {
    /**
     * @class HarmonyRefinement
     * @augments Refinement
     */
    class HarmonyRefinement extends Refinement {
        prefs() {
            return {
                ...super.prefs(),
                classesChecked: 'm-checked'
            };
        }

        /**
         * @description change price refinement value to have radio button behaviour.
         * @param {Button} target
         */
        changePrice(target) {
            // update widget state from target
            // target -- it is specific price range button
            this.config = target.config;
            this.attrId = target.config.attrId;
            this.min = target.config.valueFrom;
            this.max = target.config.valueTo;
            this.selected = true;

            // unselect all radios
            this.items.forEach(item => {
                item.ref('self').removeClass(this.prefs().classesChecked).attr('aria-checked', 'false');
            });

            // select only target radio
            target.ref('self').addClass(this.prefs().classesChecked).attr('aria-checked', 'true');

            this.eventBus().emit('refinement.state.changed', this);
        }

        /**
         * @description Toggle check status
         * @returns {void}
         */
        toggleCheck() {
            if (this.selected) {
                this.uncheck();
            } else {
                this.check();
            }

            this.eventBus().emit('refinement.state.changed', this);
        }

        onRefresh() {
            super.onRefresh();
            this.init();
        }
    }

    return HarmonyRefinement;
}
